import { createContext } from 'react';

const consumosContext = createContext();

export default consumosContext;